module.exports = __webpack_public_path__ + "img/demo5.4ac82728.jpg";